/** This is an automatically generated class by FairyGUI. Please do not modify it. **/
import UI_Upgrade from "./UI_Upgrade";
import UI_skill_view from "./UI_skill_view";
import UI_skill_item from "./UI_skill_item";
import UI_Super from "./UI_Super";
import UI_Store from "./UI_Store";
import UI_store_item from "./UI_store_item";
import UI_btn_store_tag from "./UI_btn_store_tag";
import UI_btn_change from "./UI_btn_change";
import UI_Get from "./UI_Get";
import UI_com_year_bar from "./UI_com_year_bar";
import UI_Fight from "./UI_Fight";
import UI_Challenge from "./UI_Challenge";
import UI_btn_c from "./UI_btn_c";
import UI_item_challenge from "./UI_item_challenge";
import UI_Custom from "./UI_Custom";
import UI_custom_view from "./UI_custom_view";
import UI_custom_list_item from "./UI_custom_list_item";
import UI_btn_custom_2 from "./UI_btn_custom_2";
import UI_Main from "./UI_Main";
import UI_btn_text_01 from "./UI_btn_text_01";
import UI_btn_shanggu from "./UI_btn_shanggu";
import UI_Win from "./UI_Win";
import UI_win_reward_bar from "./UI_win_reward_bar";
import UI_btn_win_get from "./UI_btn_win_get";
import UI_btn_win_close from "./UI_btn_win_close";
import UI_com_level from "./UI_com_level";
import UI_com_coin from "./UI_com_coin";
import UI_Fail from "./UI_Fail";
import UI_Revive from "./UI_Revive";
import UI_revive_view from "./UI_revive_view";
export default class MainBinder {
    static bindAll() {
        fgui.UIObjectFactory.setExtension(UI_Upgrade.URL, UI_Upgrade);
        fgui.UIObjectFactory.setExtension(UI_skill_view.URL, UI_skill_view);
        fgui.UIObjectFactory.setExtension(UI_skill_item.URL, UI_skill_item);
        fgui.UIObjectFactory.setExtension(UI_Super.URL, UI_Super);
        fgui.UIObjectFactory.setExtension(UI_Store.URL, UI_Store);
        fgui.UIObjectFactory.setExtension(UI_store_item.URL, UI_store_item);
        fgui.UIObjectFactory.setExtension(UI_btn_store_tag.URL, UI_btn_store_tag);
        fgui.UIObjectFactory.setExtension(UI_btn_change.URL, UI_btn_change);
        fgui.UIObjectFactory.setExtension(UI_Get.URL, UI_Get);
        fgui.UIObjectFactory.setExtension(UI_com_year_bar.URL, UI_com_year_bar);
        fgui.UIObjectFactory.setExtension(UI_Fight.URL, UI_Fight);
        fgui.UIObjectFactory.setExtension(UI_Challenge.URL, UI_Challenge);
        fgui.UIObjectFactory.setExtension(UI_btn_c.URL, UI_btn_c);
        fgui.UIObjectFactory.setExtension(UI_item_challenge.URL, UI_item_challenge);
        fgui.UIObjectFactory.setExtension(UI_Custom.URL, UI_Custom);
        fgui.UIObjectFactory.setExtension(UI_custom_view.URL, UI_custom_view);
        fgui.UIObjectFactory.setExtension(UI_custom_list_item.URL, UI_custom_list_item);
        fgui.UIObjectFactory.setExtension(UI_btn_custom_2.URL, UI_btn_custom_2);
        fgui.UIObjectFactory.setExtension(UI_Main.URL, UI_Main);
        fgui.UIObjectFactory.setExtension(UI_btn_text_01.URL, UI_btn_text_01);
        fgui.UIObjectFactory.setExtension(UI_btn_shanggu.URL, UI_btn_shanggu);
        fgui.UIObjectFactory.setExtension(UI_Win.URL, UI_Win);
        fgui.UIObjectFactory.setExtension(UI_win_reward_bar.URL, UI_win_reward_bar);
        fgui.UIObjectFactory.setExtension(UI_btn_win_get.URL, UI_btn_win_get);
        fgui.UIObjectFactory.setExtension(UI_btn_win_close.URL, UI_btn_win_close);
        fgui.UIObjectFactory.setExtension(UI_com_level.URL, UI_com_level);
        fgui.UIObjectFactory.setExtension(UI_com_coin.URL, UI_com_coin);
        fgui.UIObjectFactory.setExtension(UI_Fail.URL, UI_Fail);
        fgui.UIObjectFactory.setExtension(UI_Revive.URL, UI_Revive);
        fgui.UIObjectFactory.setExtension(UI_revive_view.URL, UI_revive_view);
    }
}
